module.exports = {
  create: 'Crear',
  update: 'Editar',
  delete: 'Borrar',
  delete_confirm: '¿Quieres Borrarlo？',
  confirm: 'Confirmar',
  search: 'Buscar',
  active: 'Acción',
  more: 'Más',
  excel: 'Exportar',
  
  register: {
    submit: 'Registrar',
    button: '¿Aún no tienes la cuenta?',
    back: 'Inciar sesión'
  },
  
  home: {
    hello: 'Bienvenido',
    ticket: 'Facturas',
    user_bill_post: 'Pago pendiente',
    user_bill_ok: 'Pago completado',
    time: ['Día', 'Mes'],
    cex_order: 'Envío CEX',
    cex_order_pay: 'Pendiente',
    cex_order_ok: 'Preregistrado',
    cex_order_no: 'Reembolsado',
    user_log: 'Movimientos',
    user_log_money: 'Ingresado',
    user_log_out: 'Usado'
  },
  
  user: {
    username: 'Cuenta Usuario',
    password: 'Contraseña',
    number: 'Código Cliente',
    money: 'Saldo',
    money_day: 'Liquidación',
    money_day_text: ['Usuario Prepago', 'Semanal', 'Mensual'],
    type: 'Tipo Usuario',
    type_text: ['Personal', 'Empresa'],
    type_data: [{
      name: 'Nombre',
      phone: 'Tel',
      email: 'Email',
      code: 'NIF'
    }, 
    {
      name: 'Empresa',
      phone: 'Tel',
      email: 'Email',
      code: 'CIF'
    }],
    country: 'País',
    city: 'Ciudad',
    area: 'Región',
    address: 'Dirección',
    address_code: 'Número',
    zip: 'CP',
    bank: 'Banco',
    bank_code: 'Cuenta Bancaria',
    bank_name: 'Titular',
    ticket: 'Facturación',
    ticket_text: ['Ticket', 'Factura'],
    cex_level: 'Nivel CEX',
    cex_codigo: 'Cuenta cliente CEX',
    cex_pdf_type: 'CEX Imprimir',
    cex_pdf_type_text: {
      1: 'A6 individual',
      3: 'A4 dividido en 3'
    }
  },
  
  user_log: {
    money: 'Importe',
    current: 'Saldo',
    content: 'Descripción',
    type: 'Tipo de Log',
    type_text: ['Todo', 'Pago Online'],
    money_type: 'Movimiento',
    money_type_text: ['Reducir', 'Incrementar'],
    created_at: 'Tiempo',
    
    pay: {
      title: 'Recargar',
      money: 'Importe',
      redsys: 'Pago con Redsys',
      success: '¿Ha completado el pago?'
    }
  },
  
  user_bill: {
    title: 'Cuenta',
    money: 'Importe',
    created_at: 'Tiempo',
    status: 'Estado',
    status_text: ['Pendiente', 'Completado']
  },
  
  ticket: {
    before_money: 'Base Imponible',
    tax: 'Tasa de IVA',
    tax_money: 'IVA',
    money: 'TOTAL',
    created_at: 'Fecha',
    active_pdf: 'PDF de Factura'
  },
  
  address: {
    type: 'Uso frecuente',
    name: 'Nombre',
    contact: 'Contacto',
    phone: 'Tel',
    email: 'E-mail',
    address: 'Dirección',
    number: 'Número',
    house: 'Pta.',
    zip: 'CP',
    city: 'Ciudad',
    created_at: 'Creación',
    active_type: 'Direcciones de uso frecuente',
    active_address: 'Direcciones',
    active_create: 'Guardar',
    active_update: 'Actualizar'
  },
  
  cex: {
    title: {
      cex: 'Productos-Zonas',
      bultos: 'Bultos',
      sender: 'Remitente',
      receive: 'Destinatario'
    },
    bultos: 'Número Total',
    kilos: 'Peso Total (kg)',
    take: 'Recogida',
    take_text: {
      n: 'No',
      s: 'Notificar'
    },
    seguro: 'Seguro',
    reembolso: 'Reembolso',
    refCliente: 'Referencia',
    observac: 'Observación',
    
    insure: 'Coste Seguro',
    collect: 'Coste Reembolso',
    addPrice: 'Importe Adicional',
    addWeight: 'Peso Adicional (Kg)',
    price: 'Importe de Peso',
    money: 'Total',
    button_order: 'En Espera',
    button_order_ok: 'Confirmar',
    button_tool: 'Añadir',
    
    tool: {
      title: 'Calculadora de Bultos',
      c: 'Largo(Cm)',
      k: 'Ancho(Cm)',
      g: 'Alto(Cm)',
      z: 'Peso(Kg)',
      weight: 'Peso',
      volume: 'Volumen',
      button: 'Calcular'
    },
    
    list: {
      tab0: 'En Espera',
      tab1: 'Envios De Hoy',
      active_order: 'Confirmar',
      active_no: 'Cerrar',
      active_pdf: 'Etiqueta PDF',
      button_active: 'Acción',
      button_ok: 'Confirmar Todos',
      button_ok_message: '¿Realizar todos los envios?',
      button_no: 'Cancelar Todos',
      button_no_message: '¿Cancelar todos los envios?',
      button_pdf: 'Descargar Todas',
      loading: 'Procesando, estará en Envios De Hoy'
    },
    
    query: {
      title: 'Seguimiento',
      message: 'Se permite consultas masiva, introduce un número de envio por línea',
      button: 'Consultar',
      code: 'Nº Envio',
      status: 'Estado',
      status_time: 'Tiempo'
    }
  },
  
  cex_order: {
    name: 'Destino',
    count: 'Bultos',
    weight: 'Peso',
    price: 'Importe',
    add_weight: 'Adicional',
    total_weight: 'Total',
    add_price: 'Importe Adicional',
    collect: 'Reembolso',
    insure: 'Seguro',
    cost: 'Coste',
    money: 'Total',
    waybill: 'Nº Envío',
    number: 'Código Cliente',
    data_name: 'Destinatario',
    data_phone: 'Tel',
    take: 'Recogida',
    take_code: 'Nº Recogida',
    take_text: ['No', 'Si'],
    remarks: 'Observación',
    ref: 'Referencia',
    pdf: 'Etiqueta',
    status: 'Estado',
    status_text: ['Pendiente', 'Realizado', 'Reembolsado'],
    data: 'Dato Request',
    message: 'Mensaje',
    track: 'Estado',
    track_breakdown: 'Incidencia',
    created_at: 'Tiempo',
    active_no: 'Anular',
    active_no_message: '¿Confirma el reembolso de este envio?'
  },
  
  cex_take: {
    name: 'Remitente',
    code: 'Nº Recogida',
    date: 'Fecha',
    time: 'Tiempo',
    remarks: 'Observación',
    data: 'Datos',
    status: 'Estado',
    status_text: ['Notificado', 'Cancelado'],
    created_at: 'Creación',
    active_no: 'Cancelar',
    active_no_message: '¿Cancelar la recogida?',
    
    create: {
      title: 'Recogida',
      cex: 'Producto',
      date: 'Fecha',
      time: 'Horas',
      address: 'Dirección',
      observ: 'Observación'
    }
  },
}